import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { pathA, pathB } from '../data/salesCopy';
export function TwoPaths() {
  return <section className="bg-ink py-12 text-cream sm:py-24" aria-labelledby="caminos" data-id="element-163" data-mp="25zndj99z3vti">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-164" data-mp="25xb11bmzidnu">
        <h2 id="caminos" className="max-w-2xl font-display text-[1.6rem] font-semibold leading-tight sm:text-[2.75rem]" data-id="element-165" data-mp="211lugocjrwi1">
          Hoy tenés exactamente dos caminos adelante
        </h2>

        <div className="mt-8 grid gap-4 sm:mt-12 sm:gap-6 lg:grid-cols-2" data-id="element-166" data-mp="18coi11v0otx7">
          <div className="flex h-full flex-col rounded-2xl border border-ink-line bg-ink-soft/60 p-5 sm:p-7" data-id="element-167" data-mp="1n0jach544w9r">
            <p className="text-[10px] font-medium uppercase tracking-overline text-cream/45 sm:text-[11px]" data-id="element-168" data-mp="1i9jbv7gci655">
              Camino A · Sin el método
            </p>
            <h3 className="mt-2.5 font-display text-xl text-cream/70 sm:text-2xl" data-id="element-169" data-mp="ui5iqzade6j4">
              Seguir igual que hasta ahora
            </h3>
            <ul className="mt-5 space-y-3 sm:mt-6 sm:space-y-3.5" data-id="element-170" data-mp="bw9pj56ly0sh">
              {pathA.map(item => <li key={item} className="flex gap-3 text-[14px] leading-relaxed text-cream/55 sm:text-sm" data-id="element-171" data-mp="fwjtkcauah4p">
                  <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-cream/30" data-id="element-172" data-mp="kniexqaoq5et" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex h-full flex-col rounded-2xl bg-cream p-5 text-ink ring-2 ring-champagne sm:p-7" data-id="element-173" data-mp="3p2049v6hunlk">
            <p className="text-[10px] font-medium uppercase tracking-overline text-rose sm:text-[11px]" data-id="element-174" data-mp="3t321y7krirlf">
              Camino B · Con el método
            </p>
            <h3 className="mt-2.5 font-display text-xl sm:text-2xl" data-id="element-175" data-mp="1zdeost8l2kr">
              Construir tu libertad en 21 días
            </h3>
            <ul className="mt-5 space-y-3 sm:mt-6 sm:space-y-3.5" data-id="element-176" data-mp="1dcpkh98k3v9k">
              {pathB.map(item => <li key={item} className="flex gap-3 text-[14px] leading-relaxed text-ink/80 sm:text-sm" data-id="element-177" data-mp="1ibk1q6qvlbrk">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-champagne" data-id="element-178" data-mp="sn4w7lnozo83" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 text-center sm:mt-14" data-id="element-179" data-mp="12lkmxnit4vh2">
          <p className="mx-auto max-w-2xl font-display text-lg italic text-cream/85 sm:text-2xl" data-id="element-180" data-mp="12l2jo6xq9gzn">
            La única diferencia entre las dos versiones de vos es la decisión que tomes en los
            próximos segundos.
          </p>
          <div className="mt-7 sm:mt-9" data-id="element-181" data-mp="9ukmfmjoq9u5">
            <CtaButton data-id="element-182" data-mp="4yvgn1h2nwpe">Elijo el camino B — empiezo ahora</CtaButton>
          </div>
          <p className="mt-5 text-[13px] text-cream/55 sm:text-sm" data-id="element-183" data-mp="jn8gwan701pp">
            Garantía 7 días · Acceso inmediato vía mail · Pago con Mercado Pago
          </p>
        </div>
      </div>
    </section>;
}